<template class="c-ToolPanelColumns">
    <v-card class="c-ToolPanelColumns_1 mx-0 w-100 pa-0" style="width: 100%; display: flex; flex-direction: row; max-width: 650px;" v-if="isvisible" :elevation="0">
        <v-card class="mx-0 w-100 pa-0" style="overflow: auto; width: 100%; flex-grow: 1; display: flex; flex-direction: column;" :elevation="0" color="extraLightGrey">
            <v-card-subtitle class="mt-0 consistentText">
                {{ Translate('Select the columns to include in the report. Use the search box or the filter icon to narrow the choices.') }}
            </v-card-subtitle>

            <OverflowPillGroup
                class="py-0 px-2"
                :removePill="removeColumn"
                :pills="selected_columns"
                :typeDescriptor="Translate('columns')"
                @reorder="onColumnsReorder"
                >
            </OverflowPillGroup>

            <v-card-title class="subtitle-1" v-if="false">
                Selected columns: <span v-if="selected_columns.length == 0" class="ml-3 mt-2 mb-2">None selected</span>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn plain v-bind="attrs" v-on="on">{{ selected_columns.length }} selected<v-icon>mdi-menu-down</v-icon></v-btn>
                    </template>
                    <v-card style="max-width: 550px;" :elevation="0">
                        <v-chip-group active-class="primary--text" column class="pl-2">
                            <v-chip close outlined close-icon="mdi-close" v-for="item in selected_columns" :key="item.colId" @click:close="setcolumnvisible({ColId: item.colId}, false)" color="primary">
                                <template>
                                    {{ item.headerName }}
                                </template>
                            </v-chip>
                        </v-chip-group>
                    </v-card>
                </v-menu>
            </v-card-title>
            <v-card-actions>
                <v-text-field background-color="white" outlined dense hide-details clearable :label="Translate('Search')" v-model="search" class="mb-4">
                    <template v-slot:prepend-inner>
                        <v-icon>mdi-magnify</v-icon>
                    </template>
                    <template v-slot:append-outer>

                        <v-menu offset-y :close-on-content-click="false" :close-on-click="false" v-model="filter_menuopen">
                            <template v-slot:activator="{ on, attrs }">
                                <v-badge color="primary" dot offset-y="25" offset-x="10" :value="anyFilters">
                                    <v-btn icon small v-bind="attrs" v-on="on" class="ma-0">
                                        <v-icon>mdi-filter</v-icon>
                                    </v-btn>
                                </v-badge>
                            </template>
                            <v-card @mouseleave="filter_menuopen = false">
                                <MetricTypeFilter :debugMode="debugMode"
                                                :datatypes="columnDataTypes"
                                                :initial_datatypes_selection="columnDataTypes_selection"
                                                @datatypes_changed="(values) => columnDataTypes_selection = values"
                                                :categories="columnCategories"
                                                :initial_category_selection="columnCategory_selection"
                                                @categories_changed="(values) => columnCategory_selection = values"
                                                
                                                @anyfilters="(value) => anyFilters = value">

                                </MetricTypeFilter>
                            </v-card>
                        </v-menu>

                    </template>
                </v-text-field>
            </v-card-actions>
            <div v-show="!search" v-for="(cat,k) in filterCategories" :key="k">
                <v-card-subtitle v-if="isCategoryVisible(cat)" class="consistentText" style="border-bottom: 2px solid lightGrey;">{{ filterCategoryPrefix(cat).toUpperCase() }}</v-card-subtitle>

                <ColumnItemList v-if="isCategoryVisible(cat)"
                                :ReadOnly="ReadOnly"
                                :items="getColumnsByCategory(cat)"
                                :columnLookup="column_lookup"
                                :column_default_visibility="column_default_visibility"
                                :showHelp="showHelp"
                                :addColumn="addColumn"
                                :removeColumn="removeColumn"
                                :getColumnHelp="getColumnHelp"
                                @setvisible="setcolumnvisible"
                                @setdefaulthidden="setdefaulthidden"></ColumnItemList>

            </div>

            <div v-if="search">
                <v-card-subtitle class="consistentText" style="border-bottom: 2px solid lightGrey;">{{ Translate('SEARCH RESULTS') }}</v-card-subtitle>

                <ColumnItemList :items="search_results"
                                :ReadOnly="ReadOnly"
                                :columnLookup="column_lookup"
                                :column_default_visibility="column_default_visibility"
                                :showHelp="showHelp"
                                :addColumn="addColumn"
                                :removeColumn="removeColumn"
                                :getColumnHelp="getColumnHelp"
                                @setvisible="setcolumnvisible"
                                @setdefaulthidden="setdefaulthidden"></ColumnItemList>
            </div>

        </v-card>

        <v-dialog v-model="help.visible" max-width="590">
            <v-card>
                <v-card-title class="text-h5">
                    {{ help.item ? help.item.Title : '' }}
                </v-card-title>

                <v-card-text v-html="help.item.Description">

                    <!--{{ help.item.Description }}-->
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="primary darken-1"
                           text
                           @click="help.visible = false">
                        {{ Translate('Close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import Vue from "vue";
    import helps from '../../../careHelpfulFunctions.jsx';
    import utils from '@/Shared/utils.jsx';
    import common from './common.js';
    import methods from '@/Shared/methods';

    import ColumnItemList from './columnItemList.vue';
    import MetricTypeFilter from './metricTypeFilterPopup.vue';
    import OverflowPillGroup from './overflowPillGroup.vue';

    import { appSettings } from '@/Shared/appSettings';
import overflowPillGroupVue from './overflowPillGroup.vue';

    export default {
        components: {
            ColumnItemList,
            MetricTypeFilter,
            OverflowPillGroup,
        },
        props: {
            ReadOnly: null,
            isvisible: null,
            storageKey: null,
            column_list: {
                type: Array
            },
            source: null,
            settings: null,
            columnDefs: {
                type: Array
            },
            column_default_visibility: null,
            setColumnsDefaultHidden: null,
            setColumnsVisible: null,
            debugMode: null,
            column_order: Array,
        },
        data: function () {
            return {
                categoryPanels: {},
                search: '',
                filter_menuopen: false,
                category_selection: [],
                categories: [ { text: 'Categories', divider: true } ],
                column_lookup: {},

                columnDataTypes: [
                    { text: 'Counts', filter: 'type', types: ['countColumn', 'floatColumn'] },
                    { text: 'Dates / Times', filter: 'type', types: ['dateColumn', 'dateOnlyColumn', 'timeOnlyColumn'] },
                    { text: 'Durations', filter: 'type', types: ['durationColumn'] },
                    { text: 'Percents', filter: 'type', types: ['percentColumn'] },
                    { text: 'Text Values', filter: 'type', types: ['textSetColumn', 'searchableTextColumn', 'channelTypeColumn', 'directionColumn', 'userIDColumn', 'customerIDColumn', 'phoneNumColumn'] },
                    { text: 'True / False', filter: 'type', types: ['booleanColumn'] },
                    { text: 'Sparkline', filter: 'type', types: ['sparklineColumn'] }
                ],
                columnCategories: [],
                //columnSources: [],

                columnDataTypes_selection: [],
                columnCategory_selection: [],
                columnSources_selection: [],

                anyFilters: false,

                help: {
                    visible: false,
                    item: {}
                },
                isReorderingColumns: false,
                selected_columns: [],
            }
        },
        watch: {
            columnDataTypes_selection: function (newv) {
                this.saveColumnFilters();
            },
            columnCategory_selection: function (newv) {
                this.saveColumnFilters();
            },
            columnSources_selection: function (newv) {
                this.saveColumnFilters();
            },
            visibleOrderedIds: {
                immediate: true,
                handler() {
                    // Ignore if the change originated from dragging a pill in the panel
                    if (this.isReorderingColumns) {
                        this.isReorderingColumns = false;
                        return;
                    }
                    
                    let ordered = [];
                    if (this.column_order) {
                        ordered = this.column_order
                            .map(colId => this.columnDefs.find(c => c.colId === colId))
                            .filter(c => c && !c.hide);
                    }
                    
                    const orderedIds = ordered.map(c => c.colId);
                    const remaining = this.columnDefs.filter(a => a.colId && !a.hide && !orderedIds.includes(a.colId));
                    
                    this.selected_columns = [...ordered, ...remaining];
                }
            }
        },
        created() {
            console.log(`loading ToolReportColumns _uid:${this._uid} with ${this.column_list?.length} column(s); ${this.columnDefs.length} column def(s)`);

            for (let cat of [...new Set(this.column_list.filter(a => a.ColumnUse.Filter || a.ColumnUse.Group || a.ColumnUse.Computed).map(a => a.FilterCategory || a.Category))])
                this.categoryPanels[cat] = [];

            this.categories = [
                ...this.categories,
                ...this.filterCategories.map(a => ({ text: a, category: a }))
            ];
            this.category_selection = this.filterCategories.map((a, i) => i);

            this.column_lookup = helps.toLookup(this.columnDefs, 'colId');

            //------------------------ New --------------------//

            // Populate a distinct list of categories for metric filters
            this.columnCategories = [...new Set(this.column_list.filter(a => a.ColumnUse.Filter || a.ColumnUse.Group || a.ColumnUse.Computed).map(a => a.FilterCategory || a.Category))]
                .filter(a => a)
                .toSorted((a, b) => common.byField(a, b))
                .map(a => ({ text: a.indexOf('#') <= 1 ? a.substr(a.indexOf('#') + 1) : a, filter: 'Category', category: a }));

            this.loadColumnFilters();
        },
        computed: {
            filterCategories: function () {
                return [...new Set(this.column_list.filter(a => a.ColumnUse.Filter || a.ColumnUse.Group || a.ColumnUse.Computed).map(a => a.FilterCategory || a.Category))]
                    .toSorted((a, b) => common.byField(a, b));
            },
            search_results: function () {
                const s = this.search.toLowerCase();
                return this.column_list
                    .filter(a =>
                        (a.ColumnUse.Filter || a.ColumnUse.Group || a.ColumnUse.Computed) && !a.CompoundFilter && (
                        a.ColId.toLowerCase().includes(s) ||
                        a.Title.toLowerCase().includes(s) ||
                        a.Tooltip?.toLowerCase().includes(s) ||
                        a.Description?.toLowerCase().includes(s) ||
                        a.SourceType?.toLowerCase().includes(s)
                        )
                    ).toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            visibleOrderedIds() {
                let ordered = [];
                if (this.column_order) {
                    ordered = this.column_order.filter(colId => {
                        const c = this.columnDefs.find(c => c.colId === colId);
                        return c && !c.hide;
                    });
                }
                const remaining = this.columnDefs
                    .filter(a => a.colId && !a.hide && !ordered.includes(a.colId))
                    .map(a => a.colId);
                
                return [...ordered, ...remaining].join(',');
            }
        },
        methods: {
            ...methods,
            loadColumnFilters() {
                for (let i = 0; i < this.columnDataTypes.length; i++)
                    if (appSettings.LocalStorage(this.storageKey + '-columnFilters-type:' + this.columnDataTypes[i].text + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                        this.columnDataTypes_selection.push(i);

                for (let i = 0; i < this.columnCategories.length; i++)
                    if (appSettings.LocalStorage(this.storageKey + '-columnFilters-type:' + this.columnCategories[i].text + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                        this.columnCategory_selection.push(i);

                this.anyFilters =
                    this.columnDataTypes_selection.length < this.columnDataTypes.length ||
                    this.columnCategory_selection.length < this.columnCategories.length;
            },
            saveColumnFilters() {
                for (let i = 0; i < this.columnDataTypes.length; i++)
                    appSettings.LocalStorage(this.storageKey + '-columnFilters-type:' + this.columnDataTypes[i].text + '-' + (this.source ? `-${this.source}` : ''), this.columnDataTypes_selection.includes(i) ? null : 'hidden');

                for (let i = 0; i < this.columnCategories.length; i++)
                    appSettings.LocalStorage(this.storageKey + '-columnFilters-type:' + this.columnCategories[i].text + '-' + (this.source ? `-${this.source}` : ''), this.columnCategory_selection.includes(i) ? null : 'hidden');
            },
            getColumnsByCategory(category) {
            //    return this.column_list.filter(a => (a.ColumnUse.Filter || a.ColumnUse.Group) && (a.FilterCategory || a.Category) == category && !a.CompoundFilter)
            //        .toSorted((a, b) => common.byField(a, b, 'Title'));
                //debugger;
                const visibletypes = this.columnDataTypes_selection.flatMap(i => this.columnDataTypes[i].types);
                //const visiblesources = this.columnSources_selection.map(i => this.columnSources[i].source);
                const cols = this.column_list
                    .filter(a => (a.ColumnUse.Filter || a.ColumnUse.Group || a.ColumnUse.Computed) && !a.CompoundFilter && (a.FilterCategory || a.Category) == category && visibletypes.includes(a.SourceType))
                    .toSorted((a, b) => common.byField(a, b, 'Title'));
                return cols;
            },
            isCategoryVisible(category) {
                const selected = this.columnCategory_selection.map(i => this.columnCategories[i].category);
                return selected.some(a => a == category);
            },
            setPanelState(cat, value) {
                console.log(`setPanelState(cat:${cat},value:${JSON.stringify(value)}); ${typeof value}`);

                const arr = this.categoryPanels[cat];
                arr.splice(0, arr.length);

                for (let i of value)
                    arr.push(i);

                console.log(`setPanelState(cat:${cat}) arr: ${JSON.stringify(arr)}; ${typeof value}`);
            },
            filterCategoryPrefix(cat) {
                const idx = cat.indexOf('#');
                return idx >= 0 && idx < 3 ? cat.substring(idx + 1) : cat;
            },

            setdefaulthidden(col, hidden) {
                this.setColumnsDefaultHidden(col.ColId, hidden);
            },
            setcolumnvisible(col, value) {
                this.setColumnsVisible([col.ColId], value);
            },
            showHelp(col) {
                this.help.item = col;
                this.help.visible = true;
            },
            addColumn(col) {

            },
            removeColumn(col) {
                this.setcolumnvisible({ColId: col.colId}, false)
            },
            getColumnHelp(col) {
                return col.Tooltip || col.Title || 'No title set';
            },
            onColumnsReorder(newCols) {
                this.isReorderingColumns = true;
                this.selected_columns = newCols;
                this.$emit('columnsordered', newCols);
            },
        }
    }
</script>

<style scoped>
    .consistentText {
        color: var(--v-black-base) !important; 
        opacity: 0.8 !important; 
        font-size: 14px !important; 
        text-rendering: optimizelegibility !important; 
        letter-spacing:0.1 !important;
    }
</style>